import React from 'react';
import Close from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { IconButton } from '../../../Buttons/IconButton';
import { Typography } from '../../../Typography';
import DialogIcon from '../DialogIcon';
import type { DialogIconType } from '../DialogIcon';
export interface DialogHeaderProps {
  title?: React.ReactNode;
  onClose: () => void;
  subTitle?: string;
  iconType?: DialogIconType;
  icon?: React.ReactNode;
  layout?: 'vertical' | 'horizontal';
}
const titleStyle = {
  fontSize: '18px',
  fontWeight: 600,
  lineHeight: '28px',
  color: '#101828',
  zIndex: 1,
  position: 'relative',
};
const subTitleStyle = {
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '20px',
  color: '#475467',
  zIndex: 1,
  position: 'relative',
};
const CloseButton = ({ onClose }: { onClose: () => void }) => {
  return (
    <IconButton
      aria-label="close"
      onClick={onClose}
      size="small"
      sx={{ position: 'absolute', right: 16, top: 16, zIndex: 2 }}
    >
      <Close sx={{ color: '#98A2B3' }} />
    </IconButton>
  );
};
export const DialogHeader: React.FC<DialogHeaderProps> = ({
  title,
  onClose,
  subTitle,
  icon,
  iconType,
  layout = 'vertical',
}) => {
  const {
    custom: { spacing },
  } = useTheme();
  const titleId = 'modal-title';
  if (layout === 'horizontal') {
    return (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          px: spacing?.['3xl'],
          pt: spacing?.['3xl'],
          gap: spacing?.xl,
          position: 'relative',
        }}
      >
        {icon ? icon : iconType ? <DialogIcon iconType={iconType} /> : null}
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <Box id={titleId} component="div" sx={titleStyle}>
            {title}
          </Box>
          {subTitle && <Typography sx={subTitleStyle}>{subTitle}</Typography>}
        </Box>
        <CloseButton onClose={onClose} />
      </Box>
    );
  }
  return (
    <>
      <Box sx={{ px: spacing?.['3xl'], pt: spacing?.['3xl'] }}>
        <CloseButton onClose={onClose} />
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: spacing?.xl, maxWidth: '80%' }}>
          {icon ? icon : iconType ? <DialogIcon iconType={iconType} /> : null}
          <Box id={titleId} component="div" sx={titleStyle}>
            {title}
          </Box>
        </Box>
      </Box>
      {subTitle && (
        <Typography sx={{ ...subTitleStyle, mt: spacing?.md ?? 'inherit', px: spacing?.['3xl'] ?? 'inherit' }}>
          {subTitle}
        </Typography>
      )}
    </>
  );
};
